import { render, staticRenderFns } from "./employeesDialog.vue?vue&type=template&id=8f894358&scoped=true&"
import script from "./employeesDialog.vue?vue&type=script&lang=ts&"
export * from "./employeesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./employeesDialog.vue?vue&type=style&index=0&id=8f894358&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f894358",
  null
  
)

export default component.exports